import { CreateAttachmentPayload } from "@rms-types/modules/attachment/dto";
import { Attachment } from "@rms-types/modules/attachment/entities/attachment";

import { attachmentEndpoint } from "@/constants";
import { getSnackbarMessages } from "@/helpers";
import { usePost, UsePostOptions } from "@/hooks";

export function useBulkCreateAttachment(options: UsePostOptions<Attachment[], CreateAttachmentPayload[]> = {}) {
  const { triggerPostErrorMessage } = getSnackbarMessages("Attachment");
  const endpoint = attachmentEndpoint.attachmentBulk;

  const {
    mutate: createBulkAttachment,
    error: createBulkAttachmentError,
    isPending: isCreateBulkAttachmentPending,
    ...rest
  } = usePost<Attachment[], CreateAttachmentPayload[]>({
    endpoint,
    options: {
      ...options,
      onError: (error, variables, context) => {
        options.onError && options.onError(error, variables, context);
        triggerPostErrorMessage();
      },
    },
  });

  return {
    ...rest,
    createBulkAttachment,
    isCreateBulkAttachmentPending,
    createBulkAttachmentError,
  };
}
